import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import React, { useEffect } from "react";
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import {SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { selectAuth } from '../../features/authSlice';
import { useAppDispatch } from '../../app/hooks';
import { PAGE_LIST_BUSINESS, PAGE_LOGIN } from '../../PagesNames';
import Loader from '../../components/Layout/Loader';
import { USER_TYPE_ADMIN, USER_TYPE_SALES } from '../../Constant';
import { Language } from '../../language/English';
import { useSelector } from 'react-redux';
import { Authentication } from '../../services/Authentication/Authentication';
import { API_LOGIN_RESPONSE_SUCCESSFUL } from '../../services/Authentication/AuthenticationConstants';

type FormValues = {
  email: string;
  password: string;
};

export const Login = () => {
  const navigate = useNavigate();
  const auth = useSelector(selectAuth);
  const isUserLoggedIn = auth.isAuthenticated;
  useEffect(() => {
    if (isUserLoggedIn && (auth.type === USER_TYPE_ADMIN || auth.type === USER_TYPE_SALES)) {
      toast.success(Language.WELCOME_TO_WELLNESS_DASHBOARD);
      navigate(PAGE_LIST_BUSINESS);
      return;
    }
  }, [auth]);
  const [showLoader, setShowLoader] = React.useState(false);
  const formValidation = yup.object().shape({
    email: yup.string().required().label('Email'),
    password: yup.string().required().label('Password'),
  });

  const { register, handleSubmit, formState: { errors }, } = useForm<FormValues>({
    resolver: yupResolver(formValidation),
  });

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    setShowLoader(true);
    const email = data.email;
    const password = data.password;
    const authentication = new Authentication();
    const loginData = { email, password };
    const result = await authentication.login(loginData);
    if(result === API_LOGIN_RESPONSE_SUCCESSFUL){
      // toast.success(Language.WELCOME_TO_WELLNESS_DASHBOARD);
      // navigate(PAGE_LIST_BUSINESS);
    } else {
      toast.success(Language.INVALID_EMAIL_OR_PASSWORD);
    }
    setShowLoader(false);  

  } 


  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      { showLoader ? <Loader /> : null }
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={handleSubmit(onSubmit)}>
                    <h1>Login</h1>
                    <p className="text-medium-emphasis">Sign In to your account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        {...register("email")} 
                        name="email"
                        placeholder="Username" 
                        autoComplete="username" 
                      />
                    </CInputGroup>
                      {errors?.email && (
                        <p className="errorMessage">{errors.email.message}</p>
                      )}
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        {...register("password")} 
                        name="password"
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                      />
                    </CInputGroup>
                      {errors?.password && (
                        <p className="errorMessage">{errors.password.message}</p>
                      )}
                    <CRow>
                      <CCol xs={6}>
                        <CButton type="submit" color="primary" className="px-4">
                          Login
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}
